export default __webpack_public_path__ + "bea523aa5abfcc02bced5a70d2ff5136.png";